// extracted by mini-css-extract-plugin
export default {"title":"inviteFriends_title__mivlP","close":"inviteFriends_close__w9xmu"};